import { render, staticRenderFns } from "./fukuan.vue?vue&type=template&id=0560c729&scoped=true"
import script from "./fukuan.vue?vue&type=script&lang=js"
export * from "./fukuan.vue?vue&type=script&lang=js"
import style0 from "./fukuan.vue?vue&type=style&index=0&id=0560c729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560c729",
  null
  
)

export default component.exports